export default {
    accountLogin: "အကောင့်ဝင်ပါ။",
    accountNumber: "အကောင့်နံပါတ်",
    password: "စကားဝှက်",
    egateeWebsite: "Egatee တရားဝင်ဝက်ဘ်ဆိုက်",
    iosDownloadIsNotCurrentlySupportedSoStayTuned: "{0} အပလီကေးရှင်းသည် လက်ရှိအချိန်တွင် ios ဗားရှင်းကို မပံ့ပိုးနိုင်သောကြောင့် စောင့်မျှော်ကြည့်ရှုပါ။",
    suggestion: "အကြံပြုချက်",
    downloadBuyerApp: "Egatee အက်ပ်ကို ဒေါင်းလုဒ်လုပ်ပါ။",
    aboutUs: "ကျွန်ပ်တို့အကြောင်း",
    china: "တရုတ်",
    CoteDivoire: "Côte D'ivoire",
    uganda: "ယူဂန်ဒါ",
    goDownloadEgateeAPP: "Egatee App ကိုဒေါင်းလုဒ်လုပ်ပါ။",
    downloadAPP: "{0} အက်ပ်ကို ဒေါင်းလုဒ်လုပ်ပါ။",
    downloadAppOnGP: "Google play တွင် {0} အက်ပ်ကို ဒေါင်းလုဒ်လုပ်ပါ။",
    scanQrCode: "QR ကုဒ်ကို စကင်န်ဖတ်ပါ။",
    downloadAppOnAppStore: "App Store တွင် {0} အက်ပ်ကို ဒေါင်းလုဒ်လုပ်ပါ။"
}